export default __webpack_public_path__ + "static/patt-dark-49fd0c2dc888d943e1951bfb38dcaa80.jpg";